import React from 'react'

const stats = [
  {
    value: '99.2%',
    label: 'Delivery Rate',
    desc: 'Average message delivery success rate',
  },
  {
    value: '6min',
    label: 'Setup Time',
    desc: 'Average time to connect and start sending messages',
  },
  {
    value: '99.9%',
    label: 'Uptime',
    desc: 'Platform reliability and availability',
  },
  {
    value: '85.0%',
    label: 'Response Rate',
    desc: 'Average customer response rate to automated messages',
  },
]

const Stats = () => {
  return (
    <section className="bg-white px-4 py-10 sm:px-6 sm:py-12 lg:px-16 lg:py-16">
      <div className="mx-auto w-full max-w-screen-xl rounded-[16px] bg-[#f4fdf9] px-6 py-10 sm:px-10 lg:px-12 lg:py-12">
        <div className="grid grid-cols-1 gap-6 text-center sm:grid-cols-2 sm:gap-8 lg:grid-cols-4 lg:gap-10">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-3">
              <p className="text-[32px] font-semibold leading-[1.05] tracking-[-1px] text-[#1c2329] sm:text-[36px] lg:text-[40px]">
                {item.value}
              </p>
              <div>
                <p className="text-[15px] font-semibold tracking-[-0.3px] text-[#1c2329] sm:text-[16px]">
                  {item.label}
                </p>
                <p className="mt-1 text-pretty text-[13px] leading-[1.6] tracking-[-0.3px] text-[#656f68] sm:text-[14px]">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Stats

